import { map, reduce } from "ramda";

export type GetNodeChildren<NodeType> = (node: NodeType) => NodeType[];
export type MapNode<NodeType, MappedNodeType> = (
  node: NodeType,
  children: MappedNodeType[]
) => MappedNodeType;
export type ReduceNode<NodeType, ReducedNodeType> = (
  acc: ReducedNodeType,
  node: NodeType
) => ReducedNodeType;

export const mapTree = <NodeType, MappedNodeType>(
  getNodeChildren: GetNodeChildren<NodeType>,
  mapNode: MapNode<NodeType, MappedNodeType>
) => (node: NodeType): MappedNodeType =>
  mapNode(
    node,
    mapTreeChildren(getNodeChildren, mapNode)(getNodeChildren(node))
  );

export const mapTreeChildren = <NodeType, MappedNodeType>(
  getNodeChildren: GetNodeChildren<NodeType>,
  mapNode: MapNode<NodeType, MappedNodeType>
) => (children: NodeType[]): MappedNodeType[] =>
  map((childNode: NodeType) => mapTree(getNodeChildren, mapNode)(childNode))(
    children
  );

export const reduceTree = <NodeType, ReducedType>(
  getNodeChildren: GetNodeChildren<NodeType>,
  reduceNode: ReduceNode<NodeType, ReducedType>,
  initialValue: ReducedType
) => (node: NodeType): ReducedType =>
  reduceNode(
    reduceTreeChildren(getNodeChildren, reduceNode, initialValue)(
      getNodeChildren(node)
    ),
    node
  );

export const reduceTreeChildren = <NodeType, ReducedType>(
  getNodeChildren: GetNodeChildren<NodeType>,
  reduceNode: ReduceNode<NodeType, ReducedType>,
  initialValue: ReducedType
) => (children: NodeType[]): ReducedType =>
  reduce(
    (acc: ReducedType, childNode: NodeType) =>
      reduceTree(getNodeChildren, reduceNode, acc)(childNode),
    initialValue
  )(children);



// WEBPACK FOOTER //
// ./src/utils/mapReduceTree.ts